'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');
var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');
var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
var _createClass2 = require('babel-runtime/helpers/createClass');
var _createClass3 = _interopRequireDefault(_createClass2);
var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');
var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
var _inherits2 = require('babel-runtime/helpers/inherits');
var _inherits3 = _interopRequireDefault(_inherits2);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _Svg = require('../../atoms/Svg');
var _Svg2 = _interopRequireDefault(_Svg);
var _tick = require('../../../assets/icons/tick');
var _tick2 = _interopRequireDefault(_tick);
var _close = require('../../../assets/icons/close');
var _close2 = _interopRequireDefault(_close);
var _style = require('./style');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SuccessMessage = function (_React$Component) {
  (0, _inherits3.default)(SuccessMessage, _React$Component);
  function SuccessMessage(props) {
    (0, _classCallCheck3.default)(this, SuccessMessage);
    var _this = (0, _possibleConstructorReturn3.default)(this, (SuccessMessage.__proto__ || (0, _getPrototypeOf2.default)(SuccessMessage)).call(this, props));
    _this.onClose = _this.onClose.bind(_this);
    return _this;
  }
  (0, _createClass3.default)(SuccessMessage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.show) {
        this.initTimer();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var previousShow = prevProps.show;
      var show = this.props.show;
      if (show && !previousShow) {
        this.initTimer();
      }
    }
  }, {
    key: 'onClose',
    value: function onClose() {
      var onClose = this.props.onClose;
      clearTimeout(this.timeout);
      if (onClose) {
        onClose();
      }
    }
  }, {
    key: 'initTimer',
    value: function initTimer() {
      var timer = this.props.timer;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.onClose, timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        show = _props.show,
        text = _props.text;
      return _react2.default.createElement(_style.Wrapper, null, _react2.default.createElement(_style.Fade, {
        show: show
      }, _react2.default.createElement(_style.Touchable, {
        accessibilityRole: 'none',
        onClick: this.onClose
      }, _react2.default.createElement(_Svg2.default, {
        svgPath: _tick2.default,
        height: 28,
        width: 24,
        color: '#10ce64',
        viewBox: '0 0 24 28'
      }), _react2.default.createElement(_style.Message, null, text), _react2.default.createElement(_Svg2.default, {
        svgPath: _close2.default,
        height: 24,
        width: 24,
        color: '#ffffff',
        viewBox: '0 0 24 24'
      }))));
    }
  }]);
  return SuccessMessage;
}(_react2.default.Component);
SuccessMessage.propTypes = {
  show: _propTypes2.default.bool,
  onClose: _propTypes2.default.func.isRequired,
  text: _propTypes2.default.string,
  timer: _propTypes2.default.number
};
SuccessMessage.defaultProps = {
  text: 'Dados atualizados com sucesso',
  show: false,
  timer: 4000
};
SuccessMessage.displayName = 'SuccessMessage';
exports.default = SuccessMessage;